import amazon from 'assets/img/logos/AmazonAlt.png';
import ebay from 'assets/img/logos/ebay.png';
import walmart from 'assets/img/logos/walmart.png';
import shopify from 'assets/img/logos/shopify.png';
import paypal from 'assets/img/rateShop/paypal.png';
import stk from 'assets/img/logos/stk.png';
import usps from 'assets/img/rateShop/usps.png';
import ups from 'assets/merlin/ups.png';
import fedex from 'assets/img/rateShop/fedex.png';
import dhl from 'assets/img/rateShop/dhl.png';
import apc from 'assets/img/rateShop/apc.png';
import tiktok from 'assets/img/rateShop/tiktok.png';
import wwex from 'assets/img/rateShop/wwex.png';
import seko from 'assets/img/rateShop/seko.png';
import shipstation from 'assets/img/rateShop/shipstation.png';
import etsy from 'assets/img/rateShop/etsy.png';
import woocommerce from 'assets/img/rateShop/woocommerce.png';
import faire from 'assets/img/rateShop/faire.png';
import temu from 'assets/img/rateShop/temu.png';
import alibaba from 'assets/img/rateShop/alibaba.png';
import { serviceByCode } from './rateShopConstants';

export const CARRIER_ICONS = Object.freeze({
  usps,
  stamps_com: usps,
  ups,
  ups_walleted: ups,
  fedex,
  fedex_walleted: fedex,
  amazon_buy_shipping: amazon,
  amazon_shipping_us: amazon,
  ship_with_walmart: walmart,
  dhl_express: dhl,
  dhl_express_worldwide: dhl,
  dhl_global_mail: dhl,
  apc,
  apc_postal_logistics: apc,
  'tiktok-shipping': tiktok,
  wwex_parcel: wwex,
  seko_ltl_walleted: seko
});

export const MARKETPLACE_ICONS = Object.freeze({
  amazon,
  'amazon ca': amazon,
  'amazon mx': amazon,
  ebay,
  walmart,
  shopify,
  etsy,
  woocommerce,
  faire,
  'tiktok shop us': tiktok,
  temu,
  paypal,
  alibaba,
  shipstation,
  ratebrowser: shipstation
});

const normalize = value =>
  String(value || '')
    .trim()
    .toLowerCase();
const iconFrom = (icons, value) => {
  const key = normalize(value);
  return Object.prototype.hasOwnProperty.call(icons, key) ? icons[key] : null;
};
export const carrierIconFor = carrierCode =>
  iconFrom(CARRIER_ICONS, carrierCode);
export const marketplaceIconFor = (marketplaceName, storeName) => {
  const marketplace = normalize(marketplaceName);
  if (marketplace === 'shopify' && normalize(storeName) === 'shop the king')
    return stk;
  return iconFrom(MARKETPLACE_ICONS, marketplace);
};

/** Services can appear under multiple accounts of the same brand. */
export const serviceIconFor = serviceCode => {
  const code = serviceByCode(serviceCode)?.carrierCodes.find(carrierIconFor);
  return carrierIconFor(
    code || (serviceCode === 'ups_ground_saver' ? 'ups' : '')
  );
};
